<template>
  <div>
    <div class="section1 safe-area">
      <pageTitle cn="专家评委" en="Panel of Expert Judges" type="1"></pageTitle>
      <div class="common-title-d1 mt-20">评审团由联合国UNITAR教育专员、中国教育学会学科专家、海外名校PBL教授、一线国际校长、科创行业导师共同组成，从课题深度、创新落地、双语表达、团队协作四大维度综合打分。</div>
      <div class="common-title-d2 mt-12">The judging panel is comprised of the Education Commissioner of the United Nations Institute for Training and Research (UNITAR), subject experts from the Chinese Society of Education, PBL professors from prestigious overseas universities, front-line international school principals, and mentors from the science and technology innovation industry. They will comprehensively evaluate the projects based on four dimensions: project depth, innovation implementation, bilingual expression, and team collaboration.</div>
      <div class="card-box">
        <div class="card-box-track">
          <img :src="$env.imgUrl + 'pbl4-s1-1.png'" alt="">
          <img :src="$env.imgUrl + 'pbl4-s1-2.png'" alt="">
          <!-- <img :src="$env.imgUrl + 'pbl4-s1-3.png'" alt=""> -->
          <img :src="$env.imgUrl + 'pbl4-s1-4.png'" alt="">
          <img :src="$env.imgUrl + 'pbl4-s1-5.png'" alt="">
          <img :src="$env.imgUrl + 'pbl4-s1-6.png?v=0720'" alt="">
          <img :src="$env.imgUrl + 'pbl4-s1-7.png'" alt="">
          <img :src="$env.imgUrl + 'pbl4-s1-1.png'" alt="">
          <img :src="$env.imgUrl + 'pbl4-s1-2.png'" alt="">
          <!-- <img :src="$env.imgUrl + 'pbl4-s1-3.png'" alt=""> -->
          <img :src="$env.imgUrl + 'pbl4-s1-4.png'" alt="">
          <img :src="$env.imgUrl + 'pbl4-s1-5.png'" alt="">
          <img :src="$env.imgUrl + 'pbl4-s1-6.png?v=0720'" alt="">
          <img :src="$env.imgUrl + 'pbl4-s1-7.png'" alt="">
        </div>
      </div>
    </div>
    <div class="section2" :style="'background-image: url(' + $env.imgUrl + 'pbl-bg-1.png);'">
      <div class="safe-area">
        <pageTitle cn="评价体系" en="Evaluation System" type="2"></pageTitle>
        <div class="page-flex-lr-center">
          <div class="lf">
            <div class="common-title-d3">本次赛事最终评审总分100分，由PBL过程性评价（占比40%）与终结性成果评价（占比60%）两大核心维度加权核算构成，计分规则统一、标准公开、结果透明，全程落实PBL项目式学习以评促学、全程育人的核心理念。</div>
            <div class="common-title-d4 mt-12">The final evaluation score for this competition is out of 100 points, calculated based on a weighted average of two core dimensions: PBL process evaluation (40%) and summative assessment of final outcomes (60%). The scoring rules are standardized, the criteria are publicly disclosed, and the results are transparent. Throughout the process, the competition fully embodies the core principles of PBL—using assessment to promote learning and fostering holistic development.</div>
          </div>
          <div class="rt">
            <img :src="$env.imgUrl + 'pbl4-s2.png'" alt="">
          </div>
        </div>
        <div class="common-title-d3 text-c mt-20">注：过程性评价、终结性评价原始满分均为100分，按对应权重折算后汇总为赛事最终总成绩。</div>
      </div>
    </div>
    <div class="section3">
      <div class="safe-area">
        <div class="btn-active btn">
          <div class="btn-cn">最终成绩计算公式：最终得分=过程性评价得分×40%+终结性评价得分×60%</div>
          <div class="btn-en">Formula for calculating the final grade: Final score = Formative assessment score × 40% + Summative assessment score × 60%</div>
        </div>
        <div class="btn-group">
          <div class="btn" :class="active === 0 ? 'btn-active' : ''" @click="active = 0">
            <div class="btn-cn">过程性评价评分标准</div>
            <div class="btn-en">Formative Assessment Scoring Criteria</div>
          </div>
          <div class="btn" :class="active === 1 ? 'btn-active' : ''" @click="active = 1">
            <div class="btn-cn">终结性评价评分标准</div>
            <div class="btn-en">Final Evaluation Scoring Criteria</div>
          </div>
        </div>
        <template v-if="active === 0">
          <div class="white-panel">
            <div class="common-title-d1">终结性评价聚焦PBL项目最终落地成果、综合演绎与实践输出能力，摒弃“唯结果论”片面评审模式，结合赛事四大核心参赛板块制定精细化评分细则，量化项目最终成果质量、创新水平、实操能力与综合演绎效果，全方位考核学生的探究成果转化、创新设计、艺术演绎、科创实操与现场表达能力，板块总分分值分布如下：</div>
            <div class="common-title-d2">The final evaluation focuses on the final outcomes of PBL projects, as well as students’ comprehensive presentation and practical application skills. It moves away from a one-sided “results-only” assessment model and establishes detailed scoring criteria based on the competition’s four core categories. These criteria quantify the quality of the final project outcomes, the level of innovation, practical skills, and the effectiveness of the comprehensive presentation. The evaluation comprehensively assesses students’ ability to translate research findings into practical applications, their innovative design, artistic interpretation, hands-on scientific and technological skills, and on-site presentation skills. The distribution of total points across the categories is as follows:</div>
          </div>
          <div class="page-flex-lr-top">
            <div class="white-panel mr-10">
              <div class="p-tit"><b>1</b>问题驱动与选题立项（问题辨识度与方案科学性/20分）</div>
              <div class="common-title-d2 pl">Problem-Driven Topic Selection and Project Initiation (Problem Identification and Scientific Validity of the Plan / 20 points)</div>
              <div class="common-title-d1 mt-20">重点考核学生对真实情境中核心问题的识别精准度、选题的价值性与可行性，同时评判项目初始方案的规划合理性、资源整合适配度，全面衡量学生的问题定义能力与项目顶层设计能力。</div>
              <div class="common-title-d2">This component primarily evaluates students' accuracy in identifying core problems in real scenarios, as well as the value and feasibility of the selected topic. It also assesses the rationality of the initial project plan and the adaptability of resource integration, comprehensively measuring students' problem-defining ability and top-level project design capability.</div>
              <img class="mt-12" :src="$env.imgUrl + 'pbl4-s3-1-1.png'" alt="">
            </div>
            <div class="white-panel ml-10">
              <div class="p-tit"><b>2</b>探究调研与证据收集（信息完备度与方法规范性/25分）</div>
              <div class="common-title-d2 pl"> Inquiry Research and Evidence Collection (Information Completeness and Standardization of Methods / 25 points)</div>
              <div class="common-title-d1 mt-20">重点考核学生调研方法选择的适配性、数据采集的全面性与来源合规性，同时评判证据链的完整度、信息分析的严谨性，全面衡量学生的信息检索能力与实证探究素养。</div>
              <div class="common-title-d2">This component primarily evaluates the adaptability of students' research method selection, the comprehensiveness of data collection and the compliance of sources. It also assesses the completeness of the evidence chain and the rigor of information analysis, comprehensively measuring students' information retrieval ability and empirical inquiry literacy.</div>
              <img class="mt-12" :src="$env.imgUrl + 'pbl4-s3-1-2.png'" alt="">
            </div>
          </div>
          <div class="page-flex-lr-top">
            <div class="white-panel mr-10">
              <div class="p-tit"><b>3</b>方案构思与迭代优化（创新适配性与迭代落地性/25分）</div>
              <div class="common-title-d2 pl">Scheme Conception and Iterative Optimization (Innovation Adaptability and Iterative Implementation / 25 points)</div>
              <div class="common-title-d1 mt-20">重点考核学生方案设计的创新性、对复杂场景的适配程度，同时评判多轮原型迭代的改进痕迹、方案优化的逻辑合理性，全面衡量学生的创新思维能力与问题解决实操能力。</div>
              <div class="common-title-d2">This component primarily evaluates the innovation of students' scheme design and its adaptability to complex scenarios. It also assesses the improvement traces of multiple rounds of prototype iteration and the logical rationality of scheme optimization, comprehensively measuring students' innovative thinking ability and practical problem-solving skills.</div>
              <img class="mt-12" :src="$env.imgUrl + 'pbl4-s3-1-3.png'" alt="">
            </div>
            <div class="white-panel ml-10">
              <div class="p-tit"><b>4</b>团队协作与过程履职（分工协同度与任务完成度/20分）</div>
              <div class="common-title-d2 pl">Team Collaboration and Process Performance (Division of Labor Coordination and Task Completion / 20 points)</div>
              <div class="common-title-d1 mt-20">重点考核小组内部分工的合理性、成员间沟通协作的顺畅度，同时评判各成员对应任务的完成质量、冲突协商与责任履职表现，全面衡量学生的团队适配能力与岗位执行素养。</div>
              <div class="common-title-d2">This component primarily evaluates the rationality of the internal division of labor in the group and the smoothness of communication and collaboration among members. It also assesses the completion quality of each member's assigned tasks, conflict negotiation and responsibility performance, comprehensively measuring students' team adaptation ability and post execution literacy.</div>
              <img class="mt-12" :src="$env.imgUrl + 'pbl4-s3-1-4.png'" alt="">
            </div>
          </div>
          <div class="white-panel">
              <div class="p-tit"><b>5</b>过程反思与成长沉淀（反思深度与迁移延展性/10分）</div>
              <div class="common-title-d2 pl">Process Reflection and Growth Precipitation (Reflection Depth and Migration Extension / 10 points)</div>
              <div class="common-title-d1 mt-20">重点考核学生对项目全流程问题的复盘深度、自我认知的清晰程度，同时评判经验总结的系统性、方法能力的可迁移性，全面衡量学生的元认知反思能力与长期成长潜力。</div>
              <div class="common-title-d2">This component primarily evaluates the depth of students' review of the whole project process and the clarity of self-cognition. It also assesses the systematicness of experience summary and the transferability of methods and abilities, comprehensively measuring students' metacognitive reflection ability and long-term growth potential.</div>
              <img class="mt-12" :src="$env.imgUrl + 'pbl4-s3-1-5.png'" alt="">
            </div>
        </template>
        <template v-if="active === 1">
          <div class="white-panel">
            <div class="common-title-d1 text-c">终结性评价聚焦PBL项目最终落地成果、综合演绎与实践输出能力，摒弃“唯结果论”片面评审模式，结合赛事四大核心参赛板块制定精细化评分细则，量化项目最终成果质量、创新水平、实操能力与综合演绎效果，全方位考核学生的探究成果转化、创新设计、艺术演绎、科创实操与现场表达能力，板块总分分值分布如下：</div>
            <div class="common-title-d2 text-c">  The final evaluation focuses on the final outcomes of PBL projects, as well as students’ comprehensive presentation and practical application skills. It moves away from a one-sided “results-only” assessment model and establishes detailed scoring criteria based on the competition’s four core categories. These criteria quantify the quality of the final project outcomes, the level of innovation, practical skills, and the effectiveness of the comprehensive presentation. The evaluation comprehensively assesses students’ ability to translate research findings into practical applications, their innovative design, artistic interpretation, hands-on scientific and technological skills, and on-site presentation skills. The distribution of total points across the categories is as follows:</div>
          </div>
          <div class="page-flex-lr-top">
            <div class="white-panel mr-10">
              <div class="p-tit"><b>1</b>项目路演（研究质量与综合表达/30分）</div>
              <div class="common-title-d2 pl">Project Pitch (Research Quality & Comprehensive Expression / 30 Points)</div>
              <div class="common-title-d1 mt-20">考核课题完整度、逻辑严谨性、数据真实性、分析深度与方案可行性，评判项目整体研究水平。同时考察团队汇报条理、表达流畅度、全员对项目的熟悉度，结合答辩临场应变与知识储备，综合评定学生思辨与表达素养。</div>
              <div class="common-title-d2">Assess topic completeness, logical rigor, data authenticity, analysis depth and solution feasibility to evaluate the overall research level. It also examines the team's presentation organization, verbal fluency and all members' familiarity with the project, and comprehensively rates students' critical thinking and expression literacy based on on-site defense adaptability and knowledge reserve.</div>
              <img class="mt-12" :src="$env.imgUrl + 'pbl4-s3-2-1.png'" alt="">
            </div>
            <div class="white-panel ml-10">
              <div class="p-tit"><b>2</b>宣传广告板（创意设计与主题契合度/20分）</div>
              <div class="common-title-d2 pl">Display Boards (Creative Design and Alignment with Theme / 20 points)</div>
              <div class="common-title-d1 mt-20">重点考核展板整体排版美感、创意设计新颖性、视觉呈现感染力，严格对标参赛赛道主题，评判内容匹配度、核心成果展示清晰度、理念传达精准度，兼顾美育表现力与项目特色辨识度，体现团队审美设计与成果凝练能力。</div>
              <div class="common-title-d2">This category focuses on evaluating the overall aesthetic appeal of the layout, the originality of the creative design, and the impact of the visual presentation. Entries will be strictly assessed against the theme of the competition track to evaluate the relevance of the content, the clarity of the core achievements, and the accuracy of the concepts conveyed. The evaluation will also consider both the expressive power of the aesthetic presentation and the distinctiveness of the project’s characteristics, reflecting the team’s aesthetic sensibility and ability to distill their achievements.</div>
              <img class="mt-12" :src="$env.imgUrl + 'pbl4-s3-2-2.png'" alt="">
            </div>
          </div>
          <div class="page-flex-lr-top">
            <div class="white-panel mr-10">
              <div class="p-tit"><b>3</b>舞台剧展示（团队演绎与文化表现力/30分）</div>
              <div class="common-title-d2 pl">Stage Play (Team Performance and Cultural Expression / 30 points)</div>
              <div class="common-title-d1 mt-20">重点考核剧目剧情逻辑性、主题贴合度、创意编排新颖度，同时评判团队全员参演配合度、舞台表现力、情绪感染力以及文化内核呈现效果，综合评价团队协作能力、艺术演绎能力与文化阐释能力。</div>
              <div class="common-title-d2">This section focuses on evaluating the logical coherence of the plot, the relevance to the theme, and the originality of the creative staging. It also assesses the entire team’s coordination, stage presence, emotional impact, and the effectiveness of the cultural message’s presentation, providing a comprehensive evaluation of the team’s collaborative skills, artistic interpretation, and ability to convey cultural meaning.</div>
              <img class="mt-12" :src="$env.imgUrl + 'pbl4-s3-2-3.png'" alt="">
            </div>
            <div class="white-panel ml-10">
              <div class="p-tit"><b>4</b>工程作品（原创性、实践性与创新价值/20分）</div>
              <div class="common-title-d2 pl">Engineering Projects (Originality, Practicality, and Innovative Value / 20 points)</div>
              <div class="common-title-d1 mt-20">重点考核参赛作品的自主原创程度、工艺完成度、结构合理性，评判作品是否紧扣赛道主题、贴合真实问题解决需求，同时考量作品的创新改良亮点、实际应用价值、科普实践价值，凸显学生科创实操与创新创造能力。</div>
              <div class="common-title-d2">This category focuses on evaluating the degree of originality, the quality of craftsmanship, and the structural soundness of the entries. It assesses whether the projects closely align with the competition theme and address real-world problem-solving needs, while also considering their innovative features, practical application value, and educational value in popularizing science. The evaluation highlights students’ practical skills in scientific and technological innovation as well as their ability to innovate and create.</div>
              <img class="mt-12" :src="$env.imgUrl + 'pbl4-s3-2-4.png'" alt="">
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      active: 0
    }
  }
}
</script>
<style lang="less" scoped>
.d5{
  color: #000;
  font-family: systh;
  font-size: 26px;
  margin-top: 14px;
  margin-bottom: 20px;
}
.mt-20{
  margin-top: 20px;
}
.section1{
  padding: 20px 0 40px;
}
.section2{
  padding: 80px 0 50px;
  margin-bottom: 10px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .lf{
    width: 35%;
  }
  .rt{
    flex: 1;
    margin-left: 30px;
    img{
      width: 100%;
      height: auto;
    }
  }
}
.section3{
  .btn{
    text-align: center;
    padding: 10px;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    background-color: #fff;
    cursor: pointer;
    .btn-cn{
      font-size: 16px;
      font-family: systh;
      color: #000;
    }
    .btn-en{
      font-size: 9px;
      font-family: systh;
      color: #999;
    }
    &.btn-active{
      background-color: #C9273A;
      .btn-cn{
        color: #fff;
      }
      .btn-en{
        color: #FD8E86;
      }
    }
  }
  .btn-group{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0;
    .btn{
      width: 47%;
    }
  }
}
.white-panel{
  padding: 14px 20px;
  border-radius: 12px;
  background-color: #fff;
  box-sizing: border-box;
  margin-bottom: 20px;
  flex: 1;
  img{
    width: 100%;
    height: auto;
  }
}
.ml-10{
  margin-left: 10px;
}
.mr-10{
  margin-right: 10px;
}
.p-tit{
  font-family: systh;
  font-size: 16px;
  color: #000;
  b{
    font-size: 26px;
    font-family: systh;
    color: #C9273A;
    font-style: italic;
    margin-right: 14px;
  }
}
.pl{
  padding-left: 28px;
}

.card-box{
  overflow: hidden;
  margin-top: 30px;
  position: relative;
  border-radius: 20px;
  // 两端渐变遮罩
  &::before, &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 60px;
    z-index: 2;
    pointer-events: none;
  }
  &:hover .card-box-track {
    animation-play-state: paused;
  }
}
.card-box-track{
  display: flex;
  align-items: stretch;  // 让标题和图片高度一致
  width: max-content;
  img{
    width: 210px;
    height: 300px;
    border-radius: 16px;
    margin: 0 10px;
    flex-shrink: 0;
    object-fit: cover;
  }
  // 横向循环滚动动画：向左滚动50%（一组内容的宽度），无缝衔接
  animation: cardScroll 40s linear infinite;
  &:hover {
    animation-play-state: paused;
  }
}
@keyframes cardScroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>
